import { useState } from "react";

interface Milestone {
  days: number;
  icon: string;
  label: string;
  color: string;
}

const MILESTONES: Milestone[] = [
  { days: 7, icon: "🔥", label: "1 Semaine", color: "#FF6B00" },
  { days: 30, icon: "🌟", label: "1 Mois", color: "#2196F3" },
  { days: 100, icon: "💪", label: "100 Jours", color: "#9C27B0" },
  { days: 365, icon: "🏆", label: "1 Année", color: "#FFD700" },
];

interface CelebrationState {
  open: boolean;
  milestone: Milestone | null;
  habitName: string;
}

export const useStreakCelebration = () => {
  const [celebration, setCelebration] = useState<CelebrationState>({
    open: false,
    milestone: null,
    habitName: "",
  });

  const checkAndCelebrate = (
    previousStreak: number,
    newStreak: number,
    habitName: string
  ) => {
    // Find if a milestone was just crossed
    const crossedMilestone = MILESTONES.find(
      (m) => previousStreak < m.days && newStreak >= m.days
    );

    if (crossedMilestone) {
      setCelebration({
        open: true,
        milestone: crossedMilestone,
        habitName,
      });
    }
  };

  const closeCelebration = () => {
    setCelebration({
      open: false,
      milestone: null,
      habitName: "",
    });
  };

  return {
    celebration,
    checkAndCelebrate,
    closeCelebration,
  };
};
